import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';

export default function CategoriesPage() {
  useEffect(() => {
    document.title = '全部分类 - 韩国漫画分类浏览 - 韩国漫画网';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">全部分类</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-8">全部分类</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((cat) => (
              <Link key={cat.id} to={`/category/${cat.slug}`} className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer">
                <img src={cat.image} alt={cat.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                  <h3 className="text-xl font-heading font-bold text-white mb-1">{cat.name}</h3>
                  <p className="text-sm text-white/70">{cat.description}</p>
                  <span className="mt-3 px-4 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-label">{cat.count.toLocaleString()} 部</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}